export default __webpack_public_path__ + "static/media/new_site.b486afc6.jpg";